import axios from '../../axios/index';

export default {

    getRequestDurations (httpOptions) {
        return axios.get('/api/v1/shop-drawings/request-durations', httpOptions);
    },
    getRequestDuration (id) {
        return axios.get('/api/v1/shop-drawings/request-durations/' + id);
    },

    updateRequestDuration (data) {
        let formData = new FormData();
        formData.append('expected_duration', data['expected_duration']);
        formData.append('per_position', data['per_position']);
        formData.append('min_threshold', data['min_threshold']);
        formData.append('additional_default_time', data['additional_default_time']);
        formData.append('min_expected_duration', data['min_expected_duration']);
        formData.append('type_id', data['type']['id']);
        formData.append('is_revision', data['is_revision']);
        formData.append('computed_suffix', data['suffix']);
        formData.append('difficulty_level', data['difficulty_level'])
        return axios.post('/api/v1/shop-drawings/request-durations', formData);
    },
};
